<template>
    <div>
        <v-row>
            <v-col cols="12">
                <cp-select-company
                    v-if="!client && !editMode"
                    v-model="bill.client_id"
                    :error-messages="bill.errors.list('client_id')"
                    @blur="bill.errors.remove('client_id')"
                />
                <template v-if="client">
                    <cp-clients :client="client" />
                </template>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <cp-date-picker
                    v-model="bill.billing_at"
                    label="Data da Cobrança"
                    :error-messages="bill.errors.list('billing_at')"
                    :readonly="isFormReadonly"
                    :disabled="isFormReadonly"
                    @blur="bill.errors.remove('billing_at')"
                ></cp-date-picker>
                <div class="text-caption grey--text mt-n3">
                    Data que será gerada e enviada a cobrança.
                </div>
            </v-col>

            <v-col cols="12" md="4">
                <div class="mb-2">
                    <label class="text-body-2 grey--text text--darken-2">Método de Pagamento</label>
                </div>
                <v-radio-group
                    v-model="bill.payment_method_code"
                    row
                    :error-messages="bill.errors.list('payment_method_code')"
                    :readonly="isFormReadonly"
                    :disabled="isFormReadonly"
                    @change="bill.errors.remove('payment_method_code')"
                >
                    <v-radio
                        label="Boleto/PIX"
                        value="pix_bank_slip"
                    ></v-radio>
                    <v-radio
                        label="Cartão de Crédito"
                        value="credit_card"
                    ></v-radio>
                </v-radio-group>

                <v-text-field
                    v-if="bill.payment_method_code === 'credit_card'"
                    v-model.number="bill.installments"
                    label="Parcelas"
                    type="number"
                    min="1"
                    max="12"
                    :error-messages="bill.errors.list('installments')"
                    :readonly="isFormReadonly"
                    :disabled="isFormReadonly"
                    @blur="bill.errors.remove('installments')"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
                <cp-date-picker
                    v-model="bill.due_at"
                    label="Data de Vencimento"
                    :error-messages="bill.errors.list('due_at')"
                    :readonly="editMode && !canEditDueDate"
                    :disabled="editMode && !canEditDueDate"
                    @blur="bill.errors.remove('due_at')"
                ></cp-date-picker>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="bill.code"
                    label="Código"
                    readonly
                    disabled
                    hint="Código de API"
                    persistent-hint
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
                <v-text-field
                    :value="totalValueFormatted"
                    label="Valor Total"
                    readonly
                    disabled
                ></v-text-field>
            </v-col>
        </v-row>

        <v-divider class="my-6"></v-divider>

        <bill-modules-list
            :modules="modules"
            :errors="bill.errors"
            :readonly="isFormReadonly"
            :available-modules="availableModules"
            @add-module="addModule"
            @remove-module="removeModule"
        ></bill-modules-list>
    </div>
</template>

<script>
import BillModulesList from './BillModulesList'

export default {
    components: {
        BillModulesList
    },

    props: {
        bill: {
            type: Object,
            required: true
        },
        modules: {
            type: Array,
            required: true
        },
        client: {
            type: Object
        },
        availableModules: {
            type: Array,
            default: () => []
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isFormReadonly() {
            return this.editMode
        },

        canEditDueDate() {
            return !this.bill.paid_at && !this.bill.canceled_at
        },

        totalValueFormatted() {
            const total = this.modules.reduce((sum, module) => {
                const amount = parseFloat(module.amount) || 0
                const price = parseFloat(module.price) || 0
                return sum + (amount * price)
            }, 0)

            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(total)
        }
    },

    methods: {
        addModule() {
            this.$emit('add-module')
        },

        removeModule(index) {
            this.$emit('remove-module', index)
        }
    }
}
</script>
